module.exports = __webpack_public_path__ + "static/media/PH.ba51f2ba.svg";